/* @ngInject */
function RegisterFactory($http) {
  function getCsrfToken() {
    return window.csrfToken || '';
  }

  function getData(url, params) {
    return $http.get(url, params).then(
      function (data) {
        if (data.data.success) return data.data;
        else return null;
      },
      function (error) {
        // TODO: See how to handle big errors
        return error;
      }
    );
  }

  function getDataExternal(url, params) {
    return $http.get(url, params).then(
      function (data) {
        return data.data;
      },
      function (error) {
        return error;
      }
    );
  }

  function postData(url, userData) {
    return $http
      .post(url, userData, {
        headers: {
          'X-CSRF-Token': getCsrfToken(),
        },
      })
      .then(
        function (response) {
          const { data } = response;
          return data || null;
        },
        function (error) {
          return error;
        }
      );
  }

  return {
    getInitialData: function () {
      let url = 'register/getInitializationData';
      return getData(url);
    },

    getPaymentMethods: function (paymentData) {
      let url = 'register/getPaymentMethods';
      return getData(url, { params: paymentData });
    },

    getDeliveryServiceProviders: function (deliveryData) {
      let url = 'register/getDeliveryServiceProviders';
      return getData(url, { params: deliveryData });
    },

    validateIban: function (customerData) {
      let url = 'register/validateIbanForm';
      return postData(url, customerData);
    },

    registerCustomer: function (customerData) {
      let url = 'register/createCustomerAccount';
      return postData(url, customerData);
    },
    getAddressInfo: function (addressData, apiKey) {
      let url =
        'https://real-time.data-quality-service.com/rest/auto-completion/complete_address';
      addressData.par_reduce_hits = 1;
      let params = {
        params: addressData,
        headers: {
          'X-Auth-Token': apiKey,
        },
      };
      return getDataExternal(url, params);
    },
  };
}

export default RegisterFactory;
